'use strict';

CK.endpoints.disconnect = function() {
	var socket = CK.clientSockets.users;
	socket.disconnect();

	socket.publish('offline');
};
